import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=1eb4ac83&"
import script from "./Schools.ts?vue&type=script&lang=ts&"
export * from "./Schools.ts?vue&type=script&lang=ts&"
import style0 from "./schools.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports